const translations = {
  sign_up: {
    English: "Sign up",
    Français: "S'inscrire",
  },
  login: {
    English: "Login",
    Français: "Se Connecter",
  },
  yes: {
    English: "Yes",
    Français: "Oui",
  },
  no: {
    English: "No",
    Français: "Non",
  },
  hello: {
    English: "Hello",
    Français: "Bonjour",
  },
  welcome: {
    English: "Welcome",
    Français: "Bienvenue",
  },
  goodbye: {
    English: "Goodbye",
    Français: "Au revoir",
  },
  next: {
    English: "Next",
    Français: "Suivant",
  },
  previous: {
    English: "Previous",
    Français: "Précédent",
  },
  customize: {
    English: "Customize",
    Français: "Personnaliser",
  },
  gold_renewal: {
    English: "Gold Renewal",
    Français: "Renouvellement Or",
  },
  platinum_renewal: {
    English: "Platinum Renewal",
    Français: "Renouvellement Platine",
  },
  chose: {
    English: "Chose",
    Français: "Choisir",
  },
  custom_amount: {
    English: "Write amount manually",
    Français: "Écrire le montant manuellement",
  },
  generate_pdf: {
    English: "Generate PDF",
    Français: "Générer un PDF",
  },
  years: {
    English: "Years",
    Français: "Ans",
  },
  beneficiary: {
    English: "Beneficiary",
    Français: "Bénéficiaire",
  },
  gender: {
    English: "Gender",
    Français: "Genre",
  },
  month: {
    English: "month",
    Français: "mois",
  },
  see_more_information: {
    English: "See more information",
    Français: "Voir plus d'informations",
  },
  add_beneficiary: {
    English: "Add Beneficiary",
    Français: "Ajouter un bénéficiaire",
  },
  remove_beneficiary: {
    English: "Remove Beneficiary",
    Français: "Supprimer le bénéficiaire",
  },
  promotional_offers: {
    English: "Promotional offers",
    Français: "Offres promotionnelles",
  },
  applications_management: {
    English: "Applications Management - HuGo Insurance",
    Français: "Gestion des applications - HuGo assurance",
  },
  new_application: {
    English: "New Application",
    Français: "Nouvelle Application",
  },
  create_new_application: {
    English: "Create New Application",
    Français: "Créer Une Nouvelle Application",
  },
  create_new_simulation: {
    English: "Create New Simulation",
    Français: "Créer Une Nouvelle Simulation",
  },
  per_page: {
    English: "per page",
    Français: "par page",
  },
  filter: {
    English: "Filter",
    Français: "Filtrer",
  },
  sort: {
    English: "Sort",
    Français: "Trier",
  },
  clear: {
    English: "Clear",
    Français: "Effacer",
  },
  search_by_name: {
    English: "Search by name",
    Français: "Rechercher par nom",
  },
  delete: {
    English: "Delete",
    Français: "Supprimer",
  },
  cancel: {
    English: "Cancel",
    Français: "Annuler",
  },
  simulate_a_sale: {
    English: "Simulate a Sale",
    Français: "Simuler une Vente",
  },
  open: {
    English: "Open",
    Français: "Ouvrir",
  },
  name: {
    English: "Name",
    Français: "Nom",
  },
  age: {
    English: "Age",
    Français: "Âge",
  },
  term: {
    English: "Term",
    Français: "Terme",
  },
  premium: {
    English: "Premium",
    Français: "Prime",
  },
  last_modified: {
    English: "Last modified",
    Français: "Dernière modification",
  },
  status: {
    English: "Status",
    Français: "Statut",
  },
  a_platform_powered_by: {
    English: "A platform powered by",
    Français: "Une plateforme propulsée par",
  },
  all_rights_reserved: {
    English: "All rights reserved",
    Français: "Tous droits réservés",
  },
  all: {
    English: "All",
    Français: "Tous",
  },
  in_progress: {
    English: "In progress",
    Français: "En cours",
  },
  approved: {
    English: "Approved",
    Français: "Approuvé",
  },
  denied: {
    English: "Denied",
    Français: "Refusée",
  },
  issued: {
    English: "Issued",
    Français: "Émis",
  },
  expired: {
    English: "Expired",
    Français: "Expiré",
  },
  date_recent: {
    English: "recent",
    Français: "récente",
  },
  date_oldest: {
    English: "oldest",
    Français: "la plus ancienne",
  },
  advisor_login: {
    English: "Advisor Login",
    Français: "Connexion conseiller",
  },
  my_applications: {
    English: "My Applications",
    Français: "Mes Applications",
  },
  delete_applications: {
    English: "Delete Applications",
    Français: "Supprimer des Applications",
  },
  are_you_sure_you_want_to_delete_the_selected: {
    English: "Are you sure you want to delete the selected",
    Français: "Etes-vous sûr de vouloir supprimer le fichier sélectionné",
  },
  please_select_at_least_one_application_to_delete: {
    English: "Please select at least one application to delete.",
    Français: "Etes-vous sûr de vouloir supprimer le fichier sélectionné",
  },
  page_not_found: {
    English: "Page not found",
    Français: "Page non trouvée",
  },
  it_seems: {
    English: "It seems that the page you are trying to reach no longer exists or has been moved.",
    Français: "Il semble que la page que vous essayez d'accéder n'existe plus ou a été déplacée.",
  },
  home_page: {
    English: "Home page",
    Français: "Page d'accueil",
  },
  there_are_no_applications: {
    English: "There are no applications",
    Français: "Il n'y a aucune application",
  },
  no_beneficiary: {
    English: "No Beneficiary",
    Français: "Aucun bénéficiaire",
  },
  modify: {
    English: "Modify",
    Français: "Modifier",
  },
  no_results_to_display: {
    English: "No results to display",
    Français: "Aucun résultat à afficher",
  },
  insured_amount_term: {
    English: "Insured Amount / Term",
    Français: "Montant Assuré / Terme",
  },
  options: {
    English: "Options",
    Français: "Possibilités",
  },
  premium_waiver: {
    English: "Premium Waiver",
    Français: "Exonération des primes",
  },
  accidental_dismemberment_coverage: {
    English: "Accidental Dismemberment Coverage",
    Français: "Couverture en cas de mutilation accidentelle",
  },
  without_premium_waiver: {
    English: "Without Premium Waiver",
    Français: "Sans exonération de prime",
  },
  occupational_class: {
    English: "Occupational Class",
    Français: "Classe Professionnelle",
  },
  primary_phone: {
    English: "Primary phone",
    Français: "Téléphone principal",
  },
  work_phone: {
    English: "Work phone",
    Français: "Téléphone au travail",
  },
  company: {
    English: "Company",
    Français: "Entreprise",
  },
  email: {
    English: "Email",
    Français: "Adresse courriel",
  },
  payer: {
    English: "Payer",
    Français: "Payeur",
  },
  insured: {
    English: "Insured",
    Français: "Assuré",
  },
  owner: {
    English: "Owner",
    Français: "Titulaire",
  },
  confirm: {
    English: "Confirm",
    Français: "Confirmer",
  },
  confirmed: {
    English: "Confirmed",
    Français: "Confirmé",
  },
  renewal: {
    English: "Renewal",
    Français: "Renouvellement",
  },
  return_to_applications: {
    English: "Return to My Applications",
    Français: "Revenir à la gestion des applications",
  },
  internal_server_error: {
    English: "Internal server error",
    Français: "Erreur interne du serveur",
  },
  please_note_that: {
    English: "Please note that, in order to serve you better, our website is currently under maintenance.",
    Français: "Veuillez noter que, afin de mieux vous servir, notre site Web est présentement en maintenance.",
  },
  you_will_be_able_to_access: {
    English: "You will be able to access it again shortly.",
    Français: "Vous pourrez à nouveau y accéder prochainement.",
  },
go_to_my_application: {
  English: {
    text: "Try to logout and log back in. If the problem persists please contact",
    phoneLabel: "+1 800-773-8404",
  },
  Français: {
    text: "Essayez de vous déconnecter et de vous reconnecter. Si le problème persiste, veuillez contacter le",
    phoneLabel: "+1 800-773-8404",
  },
},
  suspend_application: {
    English: "Suspend application",
    Français: "Suspendre l'application",
  },
  need_information: {
    English: "Need information",
    Français: "Besoin d'informations",
  },

  confirmation: {
    English: "Confirmation",
    Français: "Confirmation",
  },
  confirmation_text: {
    English: "The application will be saved so you can access it at another time.<br />Please note the following permitted time limits:<ul><li>To complete the whole application: 30 days from the application creation date;</li><li>To complete step 3 (Insurability): 7 days from the moment you start completing that step.</li></ul>After that period, the application will be deleted.<br />Are you sure you want to temporarily suspend the current application?",
    Français: "L'application sera enregistrée afin que vous puissiez y accéder ultérieurement.<br />Veuillez noter les limites de temps autorisées suivantes :<ul><li>Pour compléter toute l'application : 30 jours à partir de la date de création de l'application;</li>  <li>Pour compléter l'étape 3 (Assurabilité) : 7 jours à partir du moment où vous commencez à compléter cette étape.</li></ul>Passé ce délai, l'application sera supprimée.<br />Êtes-vous sûr de vouloir suspendre temporairement l'application en cours ?",
  }, claimant_charter: {
    English: "Claimant’s Charter",
    Français: "Charte du réclamant",
  },
  claimant_charter_url: {
    English: "https://www.humania.ca/en/claimants-charter/",
    Français: "https://www.humania.ca/charte-du-reclamant/",
  },
  consumer_protection: {
    English: "Consumer Protection",
    Français: "Protection des consommateurs",
  },
  consumer_protection_url: {
    English: "https://www.humania.ca/en/consumer-protection/",
    Français: "https://www.humania.ca/protection-des-consommateurs/",
  },
  declaration_of_accessibility: {
    English: "Declaration of Accessibility",
    Français: "Déclaration d’accessibilité",
  },
  declaration_of_accessibility_url: {
    English: "https://www.humania.ca/en/declaration-of-accessibility/",
    Français: "https://www.humania.ca/declaration-daccessibilite/",
  },
  file_a_complaint: {
    English: "File a Complaint",
    Français: "Formuler une plainte",
  },
  file_a_complaint_url: {
    English: "https://www.humania.ca/en/filing-a-complaint/",
    Français: "https://www.humania.ca/formuler-une-plainte/",
  },
  personal_information_protection: {
    English: "Personal Information Protection",
    Français: "Protection des renseignements",
  },
  personal_information_protection_url: {
    English: "https://www.humania.ca/en/personal-information-protection/",
    Français: "https://www.humania.ca/protection-des-renseignements/",
  },
  terms_of_use: {
    English: "Terms of Use",
    Français: "Conditions d’utilisation",
  },
  terms_of_use_url: {
    English: "https://www.humania.ca/en/terms-of-use/",
    Français: "https://www.humania.ca/conditions-dutilisation/",
  },
  supplier_and_partner_services: {
    English: "Supplier and Partner Services",
    Français: "Services aux partenaires et fournisseurs",
  },
  supplier_and_partner_services_url: {
    English: "https://www.humania.ca/en/supplier-and-partner-services/",
    Français: "https://www.humania.ca/services-aux-partenaires-et-fournisseurs/",
  },
  assuris_member: {
    English: "Assuris Member",
    Français: "Membre Assuris",
  },
  assuris_member_url: {
    English: "https://www.humania.ca/en/assuris-member/",
    Français: "https://www.humania.ca/membre-assuris/",
  },
  disconnect: {
    English: "Disconnect",
    Français: "Déconnecter",
  },
  security_number_info: {
    English: "For most cards this number appears on the back of the card at the top of the signature strip (we require the last 3 digits only). <br /><br /> On some other cards, including American Express, there is a four-digit number on the front of the card just above the account number.",
    Français: "Pour la plupart des cartes, ce numéro apparaît au dos de la carte, en haut de la bande de signature (nous n'avons besoin que des 3 derniers chiffres). <br /><br /> Sur certaines autres cartes, notamment American Express, il y a un numéro à quatre chiffres au recto de la carte, juste au-dessus du numéro de compte.",
  },
  pay_now: {
    English: "Pay Now",
    Français: "Payer maintenant",
  },
  credit_card: {
    English: "Credit Card",
    Français: "Carte De Crédit",
  },
  pre_authorized_debit: {
    English: "Pre-Authorized Debit",
    Français: "Débit Préautorisé",
  },
  cardholder_s_first_and_last_name: {
    English: "Cardholder's First and Last Name",
    Français: "Nom et prénom du titulaire de la carte",
  },
  card_number: {
    English: "Card number",
    Français: "Numéro de carte",
  },
  expiry_date: {
    English: "MM / YY",
    Français: "MM / AA",
  },
  expiration_date: {
    English: "Expiration date",
    Français: "Date d'expiration",
  },
  cvv: {
    English: "CVV",
    Français: "CVV",
  },
  security_number: {
    English: "Security number",
    Français: "Numéro de sécurité",
  },
  date_of_withdrawal: {
    English: "Date of withdraw",
    Français: "Date de débit désirée",
  },
  date_of_withdrawal_fixed: {
    English: "Date of withdraw",
    Français: "Date de débit",
  },
  select_date: {
    English: "Select date",
    Français: "Sélectionner une date",
  },
  please_a_select_date: {
    English: "Please select a date",
    Français: "Veuillez sélectionner une date",
  },
  product: {
    English: "Product",
    Français: "Produit",
  },
  insured_amount: {
    English: "Insured Amount",
    Français: "Montant Assuré",
  },
  the_premium_value_is_invalid: {
    English: "The premium value is invalid.",
    Français: "La valeur de la prime est invalide.",
  },
  try_other_options_or_contact_support: {
    English: "Try other options or contact support.",
    Français: "Essayez d'autres options ou contactez le support.",
  },
  the_monthly_premium_is_bellow_the_minimum_allowed: {
    English: "The monthly premium is bellow the minimum allowed ($12)",
    Français: "La prime mensuelle est inférieure au minimum autorisé (12 $)",
  },
  the_premium_could_reach_the_minimum_allowed: {
    English: "The premium could exceed the minimum by increasing the insured amount, choosing a longer term and/or adding optional coverages.",
    Français: "La prime pourrait atteindre le minimum permis en augmentant le montant assuré, en choisissant un terme plus élevé et/ou en ajoutant des protections facultatives.",
  },
  add_an_advisor: {
    English: "Add an advisor",
    Français: "Ajouter un conseiller",
  },
  monthly_premium: {
    English: "Monthly Premium",
    Français: "Prime mensuelle",
  },
  total_premium: {
    English: "Total Premium",
    Français: "Prime totale",
  },
  unknown: {
    English: "Unknown",
    Français: "Je ne sais pas",
  },
  not_necessary: {
    English: "Not necessary",
    Français: "Non nécessaire",
  },
  completed: {
    English: "Completed",
    Français: "Complété",
  },
  or: {
    English: "or",
    Français: "ou",
  },
  go_back: {
    English: "Go to Results",
    Français: "Revenir aux Résultats",
  },
  account_number: {
    English: "Account number",
    Français: "Numéro de compte",
  },
  banking_institution_number: {
    English: "Banking institution number",
    Français: "Numéro d'institution bancaire",
  },
  branch_transit_number: {
    English: "Branch transit number",
    Français: "Numéro de transit de la succursale",
  },
  name_of_bank: {
    English: "Name of bank",
    Français: "Nom de la banque",
  },
  branch_address: {
    English: "Branch address",
    Français: "Adresse de la succursale",
  },
  processing: {
    English: "Processing...",
    Français: "Traitement...",
  },
  to: {
    English: "to",
    Français: "au",
  },
  you_wont_retrieve_it_afterwards: {
    English: "You won’t be able to retrieve it afterwards",
    Français: "Vous ne pourrez plus le récupérer par la suite",
  },
  ok: {
    English: "Ok",
    Français: "D'accord",
  },
  payment_error: {
    English: "Payment error",
    Français: "Erreur de paiement",
  },
  an_error_occurred_during_the_payment_process: {
    English: "An error occurred during the payment process. Please try again later.",
    Français: "Une erreur s'est produite lors du processus de paiement. Veuillez réessayer plus tard.",
  },
  payment_error_invalid_expiry_date: {
    English: "Invalid expiry date. Please check the expiration date on your card.",
    Français: "Date d'expiration invalide. Veuillez vérifier la date d'expiration de votre carte.",
  },
  payment_error_invalid_card_number: {
    English: "Invalid card number. Please check the card number you entered.",
    Français: "Numéro de carte invalide. Veuillez vérifier le numéro de carte saisi.",
  },
  payment_error_invalid_cvv: {
    English: "Invalid security code (CVV). Please check your card details.",
    Français: "Code de sécurité (CVV) invalide. Veuillez vérifier les informations de votre carte.",
  },
    payment_error_429: {
    English: "Payment error - Too Many Attempts",
    Français: "Erreur de paiement - Trop de tentatives",
  },
  too_many_payment_attempts: {
    English: "Your credit card payment had too many failed attempts. The only available payment method now is pre-authorized debit.",
    Français: "Le paiement par carte de crédit a échoué à plusieurs reprises. Le seul mode de paiement disponible est désormais le prélèvement bancaire.",
  },
  total_amount_to_be_paid: {
    English: "Total insurance premium (incl. taxes)",
    Français: "Prime d'assurance totale (taxes incluses)",
  },
  you_are_about_to_pre_autorize_an_amount_of: {
    English: "You are about to pre-autorize an amount of : ",
    Français: "Vous vous apprêtez à préautoriser un montant de : ",
  },
  return_to_applications: {
    English: "Return to Applications",
    Français: "Revenir aux Applications",
  },
  unauthorized_title: {
    English: "Insufficient access rights",
    Français: "Droits d'accès insuffisants",
  },
  unauthorized_message: {
    English: "You do not have the necessary permissions to access this product.",
    Français: "Vous ne disposez pas des accès nécessaires pour accéder à ce produit.",
  },
   disease: {
    English: "Sickness/Family relationship",
    Français: "Maladie/Lien familial",
  },
  father: {
    English: "Father",
    Français: "Père",
  },
  mother: {
    English: "Mother",
    Français: "Mère",
  },
  sibling: {
    English: "Sibling",
    Français: "Frère/Sœur",
  },
};

export default translations;